export const EXPERIMENT_NAME_SIGNUP_WITH_BACKGROUND = 'signupWithBackground';
export const EXPERIMENT_NAME_GIVE_ME_FIVE = 'giveMeFive';
export const EXPERIMENT_NAME_GIVE_ME_FIVE_DESC = 'giveMeFiveDesc';
export const EXPERIMENT_NAME_DELAYED_LOGIN = 'delayedLogin';
export const EXPERIMENT_NAME_THREE_VERSUS_FIVE = 'threeVersusFive';
export const EXPERIMENT_NAME_PRODUCT_NAMING = 'productNaming';
